import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled from 'styled-components';
import { GREAT_WHITE, CALYPSO } from 'HubStyleTokens/colors';
import UIClickable from 'UIComponents/button/UIClickable';
const StyledClickableNavItem = styled(UIClickable).withConfig({
  displayName: "MobilePanelNavItem__StyledClickableNavItem",
  componentId: "sc-149sokh-0"
})(["&&{border-bottom:1px solid ", ";padding:10px 20px;height:50px;display:flex;padding-left:30px;:last-of-type{border-bottom:none;}}"], GREAT_WHITE); // display names for testing

StyledClickableNavItem.displayName = 'StyledClickableNavItem';

const MobilePanelNavItem = ({
  children,
  itemId,
  onClickItem,
  title
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledClickableNavItem, {
      onClick: () => onClickItem(itemId),
      children: /*#__PURE__*/_jsxs(UIFlex, {
        className: "nav-item-inner",
        align: "center",
        justify: "between",
        children: [title, children && /*#__PURE__*/_jsx(UIIcon, {
          name: "right",
          color: CALYPSO,
          size: "xs"
        })]
      })
    }), children]
  });
};

export default MobilePanelNavItem;